import { useRef } from 'react';
import { useMobileMode } from 'Shared/util/custom-hooks';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.min.css';
import InputText from 'Shared/components/input-text';
import { getDateFormat } from 'Shared/util/formatters';
import sv from 'date-fns/locale/sv';
import fi from 'date-fns/locale/fi';
import styles from './datepicker.css';


registerLocale('sv', sv);
registerLocale('fi', fi);


const Datepicker = ({
  selected,
  onChange,
  label,
  placeholder,
  minDate,
  popperPlacement,
  showYearPicker,
  language,
}) => {
  const inputRef = useRef();
  const isMobileMode = useMobileMode();

  return (
    <div className={styles.container}>
      <DatePicker
        key={placeholder}
        selected={selected}
        onChange={onChange}
        locale={language}
        dateFormat={getDateFormat()}
        showYearPicker={showYearPicker}
        withPortal={isMobileMode}
        customInput={(
          <InputText
            ref={inputRef}
            className={styles.customInput}
            label={label}
            labelClassName={styles.customLabel}
            isReadOnly={isMobileMode}
          />
        )}
        placeholderText={placeholder}
        popperPlacement={popperPlacement}
        minDate={minDate}
        isClearable
        strictParsing
      />
    </div>
  );
};

Datepicker.defaultProps = {
  popperPlacement: 'bottom-start',
};

Datepicker.propTypes = {
  selected: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  label: PropTypes.string,
  showYearPicker: PropTypes.bool,
  placeholder: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  popperPlacement: PropTypes.string,
  language: PropTypes.string,
};

export default Datepicker;
